import { useTheme } from "../../hooks/useTheme";
import styles from "./styles.module.css";
import { CSSProperties } from "react";
import { className as generateClassName } from "../../utils/styles";

type Props = {
  children: string;
  href?: string;
  style?: CSSProperties;
  className?: string;
  onClick?: () => void;
};

export const Button = ({
  children,
  href,
  style,
  className,
  ...others
}: Props) => {
  const { primaryColor } = useTheme();

  const props = {
    className: generateClassName([styles.button, className]),
    style: {
      backgroundColor: primaryColor,
      ...style,
    },
    ...others,
  };

  if (href) {
    return (
      <a {...props} href={href}>
        {children}
      </a>
    );
  }

  return <button {...props}>{children}</button>;
};
